import React from "react";
import ReactDOM from "react-dom/client";
import App, { preloadRoute } from "./App";
import "./styles/tokens.css";
import "./styles/dry-dock.css";

preloadRoute(window.location.pathname).catch(() => undefined).then(() => {
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
});
